/* eslint-disable max-len, no-trailing-spaces, eol-last, indent, comma-dangle, comma-spacing, prefer-const, spaced-comment, key-spacing, no-multi-spaces, semi, object-property-newline, quotes, react/display-name, id-length, operator-linebreak, react/prop-types, no-shadow, no-undef, max-lines-per-function, space-infix-ops, no-unused-vars, init-declarations */
import { serviceName } from '../resources/serviceConstants';
import { GET_TRAINING_DETAILS } from '../resources/endPoint';

export const getTrainingDetails = (emailId) => {
  if (!emailId) {
    throw new Error('Email ID is required to fetch training details.');
  }

  return {
    url: `${GET_TRAINING_DETAILS}/${emailId}`, 
    method: 'get',
    headers: { 'content-type': 'application/json' },
    authRequired: false,
    csrfToken: true,
    service: serviceName.INTEGRATION_MS, 
  };
};